/**
 * Check if the DOM contains at least one element that matches the provided selector.
 *
 * @example
 * ```ts
 * const hasElement = hasElement('.my-class');
 * console.log(hasElement); // Outputs true if at least one element with class 'my-class' exists, otherwise false
 * ```
 *
 * @param selector - The CSS selector to match elements against
 * @returns True if at least one matching element is found, otherwise false
 */
export function hasElement(selector: string): boolean {
  return document.querySelector(selector) !== null;
}
